/* Portico quiz engine. Ported from the portico-quiz-wireframe-preview artifact.
   Data source change: the wireframe fetched the pool live via the Cowork MCP bridge.
   In the theme the section emits the pool as JSON (#pq-pool, contents + per-variant image
   resolved in Liquid) plus a global plan-id->months map (#pq-plan-months). Everything
   downstream of parsePool (matchProduct, candidates, renderCard, sound) is preserved; the
   SET handle select now re-renders the card photo + contents, and the last result row is
   equalised across cards so the CTAs stay level. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pq-root]');
  if (!root) return;

  function readJson(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var CONFIG = readJson('pq-config', {});
  var RAW_POOL = readJson('pq-pool', []);
  var PLAN_MONTHS = readJson('pq-plan-months', {});
  var ENGRAVINGS = CONFIG.engravings || {};
  var CARD_TITLE_CLASS = CONFIG.cardTitleClass || 'h2';
  var COPY = CONFIG.copy || {};
  function copy(key, fallback) { return COPY[key] || fallback; }

  var FREQ = {
    A: { label: 'every day', shavesMonth: 30 },
    B: { label: 'most days', shavesMonth: 20 },
    C: { label: 'a few times a week', shavesMonth: 11 },
    D: { label: 'once a week or less', shavesMonth: 4 }
  };
  var HAIR = {
    A: { label: 'fine or normal', bladeLife: 5 },
    B: { label: 'coarse', bladeLife: 4 }
  };
  var DEMONYM = { doric: 'Dorians', ionic: 'Ionians', corinthian: 'Corinthians', dorian: 'Dorians', ionian: 'Ionians' };
  // Member people-noun for the handoff (localStorage + Klaviyo). The tiers section maps
  // exactly these via NAME_TO_SLUG; display still uses the Order name.
  var MEMBER_NOUN = { doric: 'Dorian', ionic: 'Ionian', corinthian: 'Corinthian' };
  var ORDER_NAME = { doric: 'Doric', ionic: 'Ionic', corinthian: 'Corinthian' };
  var HARDWARE_TYPES = { RZR: 1, STD: 1, LST: 1, BRS: 1 };
  var CONSUMABLE_TYPES = { BLD: 1, SOP: 1, CRM: 1 };
  var GIFT_TYPES = { BNK: 1, BWL: 1 };

  var scroller = root.querySelector('[data-pq-scroll]');
  var track = root.querySelector('[data-pq-track]');
  var PANEL_ORDER = ['hero', 'q0', 'q1', 'q2', 'transition', 'final'];
  var state = { q0: 'yes', q1: 'B', q2: 'A', hairWord: 'normal', isDexit: false, firstName: '', emailConsent: false };
  // Editor-preview answer presets — each surfaces a distinct result screen (see CONFIG.previewVariant).
  var PREVIEW_PRESETS = {
    'membership-frequent': { q0: 'yes', q1: 'A', q2: 'B', hairWord: 'coarse', isDexit: false },
    'membership-occasional': { q0: 'no', q1: 'C', q2: 'A', hairWord: 'normal', isDexit: false },
    'onetime': { q1: 'D', q2: 'A', hairWord: 'normal', isDexit: true }
  };
  var POOL = [];
  var cur = 'hero';

  var upBtn = root.querySelector('[data-pq-up]');
  var controlsEl = root.querySelector('.pq-controls');

  function panel(n) { return root.querySelector('[data-pq-panel="' + n + '"]'); }

  function setPanelHeights() {
    var h = scroller ? scroller.clientHeight : window.innerHeight;
    root.querySelectorAll('.pq-panel').forEach(function (p) { p.style.height = h + 'px'; });
    positionControls();
  }

  function positionControls() {
    if (!controlsEl) return;
    var maxH = 0;
    root.querySelectorAll('.pq-bands').forEach(function (b) { maxH = Math.max(maxH, b.offsetHeight); });
    controlsEl.style.bottom = (maxH ? maxH + 8 : 16) + 'px';
  }

  function goTo(n, instant) {
    var idx = PANEL_ORDER.indexOf(n);
    if (idx < 0) return;
    cur = n;
    var p0 = root.querySelector('.pq-panel');
    var panelH = p0 ? (parseFloat(p0.style.height) || p0.offsetHeight) : (scroller ? scroller.clientHeight : window.innerHeight);
    if (track) {
      if (instant) {
        track.style.transition = 'none';
        track.style.transform = 'translateY(-' + (idx * panelH) + 'px)';
        track.offsetHeight; // force reflow before restoring the transition
        track.style.transition = '';
      } else {
        track.style.transform = 'translateY(-' + (idx * panelH) + 'px)';
      }
    }
    if (upBtn) upBtn.hidden = (idx === 0);
    var soundBtnEl = root.querySelector('[data-pq-sound]');
    if (soundBtnEl) soundBtnEl.hidden = (idx === 0);
    positionControls();
  }

  // ── Pool parsing (contents already resolved in Liquid) ──────────────────────
  function classifyComponent(ctype) {
    var t = (ctype || '').toUpperCase();
    if (HARDWARE_TYPES[t]) return 'hardware';
    if (CONSUMABLE_TYPES[t]) return 'consumable';
    if (GIFT_TYPES[t]) return 'gift';
    return 'other';
  }

  function withKind(contents) {
    return (contents || []).map(function (c) {
      return {
        label: c.label, quantity: c.quantity, packQuantity: c.packQuantity,
        imageUrl: c.imageUrl || null,
        componentType: (c.componentType || '').toUpperCase(),
        kind: classifyComponent(c.componentType)
      };
    });
  }

  function plansForProduct(planIds) {
    var plans = [];
    (planIds || []).forEach(function (id) {
      var months = PLAN_MONTHS[String(id)];
      if (months) plans.push({ id: id, months: Number(months) });
    });
    return plans;
  }

  // Resolved gift lines (section JSON) in the shape the contents grid renders.
  function giftsFromLines(giftLines) {
    return (giftLines || []).map(function (gift) {
      return {
        label: gift.title,
        quantity: 1,
        packQuantity: 1,
        componentType: null,
        imageUrl: gift.image,
        kind: 'gift'
      };
    });
  }

  // Split a variant's PAID content lines (SET view). Consumables recur in the
  // refill; everything else is what the set contains. Nothing here is a gift:
  // gifts come from the metaobjects and leave paid contents when they do, so a
  // gift-typed line still sitting in contents is a paid line until it moves.
  function bucketContents(contents) {
    return {
      contents: contents,
      shipmentContents: contents.filter(function (c) { return c.kind === 'consumable'; }),
      setContents: contents.filter(function (c) { return c.kind !== 'consumable'; })
    };
  }

  function parsePool(products) {
    return products.map(function (p) {
      var ptype = (p.productType || '').toUpperCase();
      var variants = p.variants || [];

      // An Order exposes one variant, the Refill: the Welcome Shipment variants
      // are not published to the Online Store. The old lookup for one, and the
      // Welcome-minus-Refill diff it fed, are gone with it.
      var rflVar = variants.filter(function (v) { return v.title === 'Refill Shipment'; })[0] || null;
      var bamVar = variants.filter(function (v) { return v.title === 'Bamboo'; })[0] || (ptype === 'SET' ? variants[0] : null);

      var primaryVar = ptype === 'MEM' ? (rflVar || variants[0]) : bamVar;
      var primaryContents = withKind(primaryVar ? primaryVar.contents : []);

      // Welcome gifts arrive resolved from the permanent_gift metaobjects in
      // the section's pool JSON. They used to be recomputed here two different
      // ways — a Welcome-minus-Refill label diff for memberships, a ,BNK,BWL,
      // product-type bucket for sets — and both had to agree with what the
      // checkout button adds, so neither computes them any more.
      var gifts = giftsFromLines(p.giftLines);
      var shipmentContents = [], hardware = [];
      if (ptype === 'MEM') {
        // A refill shipment is consumables by definition.
        shipmentContents = primaryContents.filter(function (c) { return c.kind === 'consumable'; });
      } else if (ptype === 'SET') {
        var b = bucketContents(primaryContents);
        shipmentContents = b.shipmentContents;
        hardware = b.setContents;
      }

      var bladeLine = primaryContents.filter(function (c) { return c.componentType === 'BLD'; })[0];
      var boxBlades = bladeLine ? bladeLine.packQuantity * bladeLine.quantity : null;

      var sellingPlans = plansForProduct(p.sellingPlanIds);
      var cadences = [];
      sellingPlans.forEach(function (s) { if (cadences.indexOf(s.months) < 0) cadences.push(s.months); });
      cadences.sort(function (a, b) { return a - b; });

      var requiresRazor = ptype === 'MEM';

      // Per-variant view for SET handle swap: image + parsed contents keyed by variant id.
      var variantData = {};
      variants.forEach(function (v) {
        variantData[String(v.id)] = { image: v.imageUrl || p.imageUrl || null, contents: withKind(v.contents), price: v.price };
      });

      var handleOptions = [];
      if (ptype === 'SET') {
        variants.forEach(function (v) {
          var mat = /chrome/i.test(v.title) ? 'Chrome' : (/bamboo/i.test(v.title) ? 'Bamboo' : null);
          if (mat && !handleOptions.some(function (h) { return h.material === mat; })) handleOptions.push({ material: mat, variantId: v.id });
        });
        handleOptions.sort(function (a, b) { return a.material === 'Bamboo' ? -1 : b.material === 'Bamboo' ? 1 : 0; });
        if (!handleOptions.length) handleOptions = [{ material: 'Bamboo', variantId: bamVar ? bamVar.id : null }, { material: 'Chrome', variantId: null }];
      }

      return {
        id: p.id, title: p.title, productType: ptype,
        available: p.available !== false,
        description: p.description || '',
        descLead: p.descLead || '', descDetail: p.descDetail || '',
        imageUrl: p.imageUrl || null,
        url: p.url || null,
        price: primaryVar ? primaryVar.price : null,
        refillPrice: rflVar ? rflVar.price : null,
        handleOptions: handleOptions, variantData: variantData,
        sellingPlans: sellingPlans, cadences: cadences,
        boxBlades: boxBlades, requiresRazor: requiresRazor,
        planBeginPrice: p.planBeginPrice != null ? p.planBeginPrice : null,
        planRefillPrice: p.planRefillPrice != null ? p.planRefillPrice : null,
        primaryVariantId: primaryVar ? primaryVar.id : null,
        bamboVariantId: bamVar ? bamVar.id : null,
        shipmentContents: shipmentContents, gifts: gifts, hardware: hardware,
        // Resolved from the permanent_gift metaobjects by the section, not
        // recomputed here; drives the direct-to-checkout add.
        giftLines: p.giftLines || [],
        allContents: primaryContents,
        ready: boxBlades != null && (cadences.length > 0 || ptype === 'SET')
      };
    });
  }

  function findProd(id) { return POOL.filter(function (p) { return String(p.id) === String(id); })[0] || null; }

  // SET view for a chosen handle variant (falls back to the primary parse).
  function setVariantView(prod, variantId) {
    var vd = prod.variantData && prod.variantData[String(variantId)];
    // Gifts are per product, not per handle, so they come off the product in
    // both branches; only the contents change with the chosen handle.
    if (!vd) return { image: prod.imageUrl, hardware: prod.hardware, shipmentContents: prod.shipmentContents, gifts: prod.gifts, allContents: prod.allContents };
    var b = bucketContents(vd.contents);
    return { image: vd.image || prod.imageUrl, hardware: b.setContents, shipmentContents: b.shipmentContents, gifts: prod.gifts, allContents: vd.contents };
  }

  // ── Maths (cadence-model) ───────────────────────────────────────────────────
  function custBladesYear(sm, bl) { return sm * 12 / bl; }
  function deliveredBlades(box, m) { return box * 12 / m; }

  function matchProduct(prod, sm, bl) {
    if (prod.boxBlades == null || !prod.cadences.length) return null;
    var need = custBladesYear(sm, bl);
    var scored = prod.cadences.filter(function (m) { return m <= 12; }).map(function (m) {
      var matchPlan = prod.sellingPlans.filter(function (s) { return s.months === m; })[0];
      return { months: m, delivered: deliveredBlades(prod.boxBlades, m), excess: deliveredBlades(prod.boxBlades, m) - need, spId: matchPlan ? matchPlan.id : null };
    });
    var over = scored.filter(function (c) { return c.excess >= -1e-9; })
      .sort(function (a, b) { return a.excess - b.excess || Math.abs(a.months - 4) - Math.abs(b.months - 4); });
    if (over.length) return over[0];
    return scored.sort(function (a, b) { return b.delivered - a.delivered; })[0];
  }

  function candidates(ownsRazor, sm, bl) {
    return POOL
      .filter(function (p) { return p.available && p.requiresRazor === ownsRazor && p.boxBlades != null && p.cadences.length > 0; })
      .map(function (p) { return { product: p, match: matchProduct(p, sm, bl) }; })
      .filter(function (x) { return x.match; })
      .sort(function (a, b) {
        var ax = a.match.excess < 0 ? Infinity : a.match.excess;
        var bx = b.match.excess < 0 ? Infinity : b.match.excess;
        return ax - bx || Math.abs(a.match.months - 4) - Math.abs(b.match.months - 4);
      });
  }

  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function orderName(title) {
    var m = (title || '').match(/the\s+(\w+)\s+order/i);
    return m ? m[1] : (title || '');
  }

  function tierKey(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('corinthian') >= 0) return 'corinthian';
    if (t.indexOf('ionic') >= 0 || t.indexOf('ionian') >= 0) return 'ionic';
    if (t.indexOf('doric') >= 0 || t.indexOf('dorian') >= 0) return 'doric';
    return null;
  }
  function membershipFor(setProd) {
    var key = tierKey(setProd.title);
    if (!key) return null;
    return POOL.filter(function (p) { return p.productType === 'MEM' && tierKey(p.title) === key; })[0] || null;
  }

  function photoHtml(imageUrl, alt) {
    return imageUrl
      ? '<div class="pq-card-photo"><img src="' + esc(imageUrl) + '" alt="' + esc(alt) + '" loading="lazy"></div>'
      : '<div class="pq-card-photo"><div class="pq-media-ph">Product image</div></div>';
  }

  // Engraving slot shows only for Portico tier cards (Doric/Ionic/Corinthian); image from schema.
  function engravingHtml(prod) {
    var tk = tierKey(prod.title);
    if (!tk) return '';
    var url = ENGRAVINGS[tk];
    var inner = url ? '<img src="' + esc(url) + '" alt="">' : '<div class="pq-media-ph">Engraving<em>' + esc(orderName(prod.title)) + '</em></div>';
    return '<div class="pq-card-engraving">' + inner + '</div>';
  }

  // Component grid (thumbnail + label), mirroring the theme's Kit Contents snippet.
  function contentsGrid(items) {
    if (!items || !items.length) return '';
    var lis = items.map(function (c) {
      var img = c.imageUrl
        ? '<img class="portico-contents__image" src="' + esc(c.imageUrl) + '" alt="' + esc(c.label) + '" loading="lazy">'
        : '';
      return '<li class="portico-contents__item">' + img + '<span class="portico-contents__label">' + esc(c.label) + '</span></li>';
    }).join('');
    return '<ul class="portico-contents" role="list">' + lis + '</ul>';
  }

  var DISCLOSURE_CARET = '<svg class="pq-disclosure__caret" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg>';
  function disclosure(kind, heading, bodyHtml, isOpen) {
    if (!bodyHtml) return '';
    return '<details class="pq-disclosure" data-pq-dd="' + kind + '"' + (isOpen ? ' open' : '') + '>'
      + '<summary class="pq-disclosure__summary"><span class="pq-disclosure__title">' + esc(heading) + '</span>' + DISCLOSURE_CARET + '</summary>'
      + '<div class="pq-disclosure__content">' + bodyHtml + '</div></details>';
  }

  function renderCard(prod, matchData, isHero, mode, activeVariantId) {
    var heroClass = isHero ? ' pq-card--hero' : '';
    var badge = isHero ? '<div class="pq-card-badge badge">' + esc(CONFIG.copy && CONFIG.copy.badge || 'Your Reading') + '</div>' : '';

    var setView = prod.productType === 'SET' ? setVariantView(prod, activeVariantId || (prod.handleOptions[0] && prod.handleOptions[0].variantId)) : null;
    var photo = photoHtml(setView ? setView.image : prod.imageUrl, prod.title);
    var engraving = engravingHtml(prod);

    var mem = prod.productType === 'SET' ? membershipFor(prod) : null;

    // Price line. MEM: "£X per refill". SET subscription: "£X to begin · £Y per refill". SET one-time: "£X".
    var price = prod.price ? '£' + Math.round(parseFloat(prod.price)) : '';
    var priceHtml = '';
    if (prod.productType === 'SET' && mode === 'subscription') {
      // Begin/refill come from the set's Seal plan (Fixed = first order, Recurring = refill), not the listing price.
      var beginPrice = (prod.planBeginPrice != null) ? prod.planBeginPrice : prod.price;
      var beginTxt = beginPrice ? '£' + Math.round(parseFloat(beginPrice)) : '';
      var setRefillPrice = (prod.planRefillPrice != null) ? prod.planRefillPrice : ((mem && mem.refillPrice) || prod.refillPrice);
      var refillTxt = setRefillPrice ? ' · £' + Math.round(parseFloat(setRefillPrice)) + ' per refill' : '';
      if (beginTxt) priceHtml = '<p class="pq-card-price"><span class="amt">' + beginTxt + '</span> to begin' + refillTxt + '</p>';
    } else if (price) {
      if (prod.productType === 'SET') {
        priceHtml = '<p class="pq-card-price"><span class="amt">' + price + '</span></p>';
      } else {
        priceHtml = '<p class="pq-card-price"><span class="amt">' + price + '</span> per refill</p>';
      }
    }

    // Description under the price — lead + contents, two muted lines.
    var descHtml = '';
    if (prod.descLead) {
      descHtml = '<div class="pq-card-desc"><span class="pq-card-desc-lead">' + esc(prod.descLead) + '</span>'
        + (prod.descDetail ? '<span class="pq-card-desc-detail">' + esc(prod.descDetail) + '</span>' : '') + '</div>';
    }

    // Cadence row — subscription paths only (MEM and SET step-down), never one-time.
    var cadenceHtml = '';
    if (mode === 'subscription') {
      var cadMonths = null, cadDelivered = null;
      if (prod.productType === 'MEM' && matchData) {
        cadMonths = matchData.months; cadDelivered = matchData.delivered;
      } else if (prod.productType === 'SET') {
        cadMonths = (matchData && matchData.months) || (mem && mem.cadences[0]) || prod.cadences[0];
        var cadBox = (mem && mem.boxBlades) || prod.boxBlades;
        cadDelivered = (matchData && matchData.delivered) ? matchData.delivered : (cadBox && cadMonths ? cadBox * 12 / cadMonths : null);
      }
      if (cadMonths) {
        var bladesSub = cadDelivered ? '<span class="pq-card-sub">= ' + Math.round(cadDelivered) + ' blades a year</span>' : '';
        cadenceHtml = '<div class="pq-card-row pq-card-cadence"><span class="pq-card-row-label">' + esc(copy('cadenceLabel', 'Refill Frequency')) + '</span>'
          + '<span class="pq-card-row-value">Ships every <b>' + cadMonths + ' months</b>' + bladesSub + '</span></div>';
      }
    }

    // Handle row — SET only. Variant selector as pills; a hidden input carries the chosen variant.
    var handleHtml = '';
    if (prod.productType === 'SET' && prod.handleOptions && prod.handleOptions.length) {
      var firstHandleId = prod.handleOptions[0].variantId || '';
      var pills = prod.handleOptions.map(function (h, i) {
        return '<button type="button" class="pq-pill' + (i === 0 ? ' is-selected' : '') + '" data-pq-handle-opt data-variant-id="' + esc(String(h.variantId || '')) + '">' + esc(h.material) + '</button>';
      }).join('');
      handleHtml = '<div class="pq-card-row pq-card-handle"><span class="pq-card-row-label">' + esc(copy('handleLabel', 'Razor handle')) + '</span>'
        + '<span class="pq-card-row-value"><span class="pq-pills">' + pills + '</span>'
        + '<input type="hidden" data-pq-handle value="' + esc(String(firstHandleId)) + '"></span></div>';
    }

    // Dropdowns (Kit-Contents style). Open/closed defaults per card type; opening one syncs the same kind across cards.
    // The welcome gift gets its own dropdown on both card types. It used to be
    // folded into a SET card's Set Contents, which listed a £0 gift among the
    // items the customer is paying for, and disagreed with the tier cards and
    // the ritual-set section now that all three read the same metaobjects.
    var giftDropdown = function () {
      if (!prod.gifts.length) return '';
      var heading = copy('giftHeading', 'Welcome Gift(s)').replace('(s)', prod.gifts.length > 1 ? 's' : '');
      return disclosure('gift', heading,
        '<p class="pq-disclosure__intro">' + esc(copy('giftIntro', 'With our compliments…')) + '</p>' + contentsGrid(prod.gifts), true);
    };

    var dropdownsHtml = '';
    if (prod.productType === 'MEM') {
      dropdownsHtml = giftDropdown()
        + disclosure('refill', copy('refillHeading', 'Refill Shipments'), contentsGrid(prod.shipmentContents), false);
    } else if (prod.productType === 'SET' && mode === 'subscription') {
      var refillItems = (mem && mem.shipmentContents.length ? mem.shipmentContents : setView.shipmentContents);
      var setBody = '<div data-pq-contents>' + contentsGrid(setView.hardware) + '</div>'
        + '<p class="pq-disclosure__note">' + esc(copy('setRefillNote', '+ Refill shipments')) + '</p>';
      dropdownsHtml = giftDropdown()
        + disclosure('refill', copy('refillHeading', 'Refill Shipments'), contentsGrid(refillItems), true)
        + disclosure('set', copy('setContentsHeading', 'Set Contents'), setBody, false);
    } else {
      // SET one-time (D-exit): everything in the set, no cadence, no refill.
      var allBody = '<div data-pq-contents>' + contentsGrid(setView ? setView.allContents : prod.allContents) + '</div>';
      dropdownsHtml = disclosure('set', copy('setContentsHeading', 'Set Contents'), allBody, true);
    }

    // Checkout data: MEM uses its Welcome variant; SET uses the selected handle variant (read at click).
    var variantId = prod.productType === 'MEM' ? (prod.primaryVariantId || '') : (activeVariantId || (prod.handleOptions[0] && prod.handleOptions[0].variantId) || '');
    var spId = (mode === 'subscription' && matchData && matchData.spId) ? matchData.spId : '';

    var ctaText = 'View';
    if (prod.productType === 'MEM') ctaText = 'Join the ' + esc(prod.title);
    else if (prod.productType === 'SET') ctaText = 'Begin with ' + esc(prod.title);

    return '<div class="pq-card' + heroClass + '" data-pq-type="' + prod.productType + '" data-pq-prod-id="' + esc(String(prod.id)) + '" data-pq-mode="' + mode + '">'
      + badge + photo + engraving
      + '<div class="pq-card-inner">'
      + '<h3 class="pq-card-title ' + CARD_TITLE_CLASS + '">' + esc(prod.title) + '</h3>'
      + priceHtml + descHtml + cadenceHtml + handleHtml
      + ctaButton(prod, variantId, spId, ctaText)
      + '<div class="pq-card-disclosures">' + dropdownsHtml + '</div>'
      + '</div></div>';
  }

  // A sold-out product keeps its card for comparison but cannot be joined.
  function ctaButton(prod, variantId, spId, ctaText) {
    if (!prod.available) {
      var soldOut = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      return '<button class="button pq-card-cta" disabled>' + esc(soldOut) + '</button>';
    }
    return '<button class="button pq-card-cta" data-pq-join data-variant-id="' + esc(String(variantId)) + '" data-selling-plan="' + esc(String(spId)) + '">' + ctaText + '</button>';
  }

  function showFinal(name) {
    ['capture', 'result'].forEach(function (n) {
      var el = root.querySelector('[data-pq-final="' + n + '"]');
      if (el) el.hidden = (n !== name);
    });
  }
  function showCapture() { showFinal('capture'); }

  // Equalise the cadence row across the visible cards so the rule above the CTA lines up.
  // Only at the 3-up desktop breakpoint; reset to auto below it.
  function equaliseCadenceRows() {
    var cardsEl = root.querySelector('[data-pq-cards]');
    if (!cardsEl) return;
    var cards = Array.prototype.slice.call(cardsEl.querySelectorAll('.pq-card'));
    var rows = cards.map(function (c) { return c.querySelector('.pq-card-cadence'); }).filter(Boolean);
    rows.forEach(function (r) { r.style.height = 'auto'; });
    if (rows.length < 2 || !window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
    var max = 0;
    rows.forEach(function (r) { max = Math.max(max, r.offsetHeight); });
    rows.forEach(function (r) { r.style.height = max + 'px'; });
  }

  function cap(s) { s = s || ''; return s.charAt(0).toUpperCase() + s.slice(1); }

  function showResult(isDExit) {
    var titleEl = root.querySelector('[data-pq-title]');
    var profileEl = root.querySelector('[data-pq-profile]');
    var cardsEl = root.querySelector('[data-pq-cards]');
    var reassuranceEl = root.querySelector('[data-pq-reassurance]');
    var cards = [];
    var setHead = function (title, profileHtml) {
      if (titleEl) titleEl.textContent = title;
      if (profileEl) profileEl.innerHTML = profileHtml;
    };

    if (isDExit) {
      var freqLabel = (FREQ[state.q1] && FREQ[state.q1].label) || 'infrequently';
      var hairWordD = state.hairWord || (HAIR[state.q2] && HAIR[state.q2].label) || '';
      setHead(copy('dexitTitle', 'The Oracle Reads An Unhurried Hand'),
        cap(esc(hairWordD)) + ' hair · ' + cap(esc(freqLabel))
        + '<span class="pq-profile-note">' + esc(copy('dexitNote', 'You shave only now and then, so a refill membership would oversupply you. A single set is all you need.')) + '</span>');
      POOL.filter(function (p) { return p.productType === 'SET'; })
        .sort(function (a, b) { return (parseFloat(a.price) || 0) - (parseFloat(b.price) || 0); })
        .forEach(function (p) { cards.push(renderCard(p, null, false, 'onetime')); });
      if (reassuranceEl) reassuranceEl.hidden = true; // membership path only
    } else {
      var sm = FREQ[state.q1] && FREQ[state.q1].shavesMonth;
      var bl = HAIR[state.q2] && HAIR[state.q2].bladeLife;
      var owns = state.q0 === 'yes';
      var hairWord = state.hairWord || (HAIR[state.q2] && HAIR[state.q2].label) || '';
      var freqLabel2 = (FREQ[state.q1] && FREQ[state.q1].label) || '';
      var recs = candidates(owns, sm, bl);
      var hero = recs[0];

      if (hero && sm && bl) {
        var blades = Math.round(custBladesYear(sm, bl));
        var t = hero.product.title || '';
        var lower = t.toLowerCase();
        var demonym = '';
        for (var k in DEMONYM) { if (lower.indexOf(k) >= 0) { demonym = DEMONYM[k]; break; } }
        var oracleTitle = demonym ? 'The Oracle Places You With The ' + demonym : 'The Oracle Places You With ' + t;
        setHead(oracleTitle,
          cap(esc(hairWord)) + ' hair · ' + cap(esc(freqLabel2))
          + ' <span class="pq-profile-arrow" aria-hidden="true">→</span> <b class="pq-blades">≈ ' + blades + ' blades a year</b>');
      } else {
        setHead('Your reading', 'Add products to the Recommendable collection to see your reading.');
      }

      var ordered = recs.slice().sort(function (a, b) { return (parseFloat(a.product.price) || 0) - (parseFloat(b.product.price) || 0); });
      ordered.forEach(function (x) { cards.push(renderCard(x.product, x.match, !!hero && x.product.id === hero.product.id, 'subscription')); });
      if (reassuranceEl) reassuranceEl.hidden = false; // membership path shows reassurance
    }

    if (cardsEl) cardsEl.innerHTML = cards.join('');
    showFinal('result');
    if (controlsEl) controlsEl.style.display = 'none';
    stopAmbient();
    requestAnimationFrame(equaliseCadenceRows);
  }

  // ── Sound engine (verbatim) ────────────────────────────────────────────────
  var audioCtx = null;
  function getAudioCtx() {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === 'suspended') audioCtx.resume();
    return audioCtx;
  }
  function applyEnvelope(gainNode, startTime, peak, attack, decay) {
    gainNode.gain.setValueAtTime(0.0001, startTime);
    gainNode.gain.exponentialRampToValueAtTime(peak, startTime + attack);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + attack + decay);
  }
  function playTone(cue) {
    var ctx = getAudioCtx(), t = ctx.currentTime;
    if (cue === 'A') {
      var buf = ctx.createBuffer(1, ctx.sampleRate * 0.05, ctx.sampleRate);
      var bd = buf.getChannelData(0);
      for (var i = 0; i < bd.length; i++) bd[i] = Math.random() * 2 - 1;
      var n = ctx.createBufferSource(); n.buffer = buf;
      var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 2600; bp.Q.value = 6;
      var ng = ctx.createGain(); applyEnvelope(ng, t, 0.4, 0.003, 0.042);
      n.connect(bp).connect(ng).connect(ctx.destination);
      var o = ctx.createOscillator(); o.type = 'triangle'; o.frequency.value = 190;
      var og = ctx.createGain(); applyEnvelope(og, t, 0.18, 0.004, 0.056);
      o.connect(og).connect(ctx.destination);
      n.start(t); o.start(t); o.stop(t + 0.08);
    } else if (cue === 'B') {
      [110, 165].forEach(function (f, i) {
        var o = ctx.createOscillator(); o.type = 'sine'; o.frequency.value = f;
        var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 900;
        var g = ctx.createGain(); applyEnvelope(g, t, i ? 0.14 : 0.28, 0.04, 0.86);
        o.connect(lp).connect(g).connect(ctx.destination);
        o.start(t); o.stop(t + 1.0);
      });
    } else if (cue === 'C') {
      var fund = 196;
      [1, 2.01, 2.71, 3.94, 5.12].forEach(function (r, i) {
        var o = ctx.createOscillator(); o.type = 'sine';
        o.frequency.value = fund * r * (1 + (Math.random() - 0.5) * 0.004);
        var g = ctx.createGain(); applyEnvelope(g, t, 0.02 / Math.pow(i + 1, 0.9), 0.02, 2.6 - i * 0.3);
        o.connect(g).connect(ctx.destination);
        o.start(t); o.stop(t + 3.0);
      });
    }
  }
  var soundBtn = root.querySelector('[data-pq-sound]');
  function cueSound(cue) {
    if (!soundBtn || soundBtn.getAttribute('aria-pressed') !== 'true') return;
    playTone(cue);
  }

  // ── Ambient bed ─────────────────────────────────────────────────────────────
  var AMBIENT_URL = CONFIG.ambientUrl || '';
  var AMBIENT_VOL = (CONFIG.ambientVolume != null) ? Number(CONFIG.ambientVolume) : 0.15;
  var ambientEl = document.createElement('audio');
  ambientEl.loop = true; ambientEl.volume = 0;
  if (AMBIENT_URL) { ambientEl.src = AMBIENT_URL; document.body.appendChild(ambientEl); }
  var ambientUnlocked = false;
  function startAmbient() {
    ambientUnlocked = true;
    if (!AMBIENT_URL || AMBIENT_VOL <= 0) return;
    if (!soundBtn || soundBtn.getAttribute('aria-pressed') !== 'true') return;
    if (!ambientEl.paused) return;
    ambientEl.volume = 0;
    ambientEl.play().catch(function () {});
    var step = Math.max(AMBIENT_VOL / 19, 0.002);
    var fadeIn = function () {
      ambientEl.volume = Math.min(ambientEl.volume + step, AMBIENT_VOL);
      if (ambientEl.volume < AMBIENT_VOL) requestAnimationFrame(fadeIn);
    };
    requestAnimationFrame(fadeIn);
  }
  function stopAmbient() {
    if (ambientEl.paused) return;
    var step = Math.max(AMBIENT_VOL / 180, 0.001);
    var fadeOut = function () {
      ambientEl.volume = Math.max(ambientEl.volume - step, 0);
      if (ambientEl.volume > 0.001) requestAnimationFrame(fadeOut); else ambientEl.pause();
    };
    requestAnimationFrame(fadeOut);
  }

  // ── Flow wiring ───────────────────────────────────────────────────────────
  root.querySelectorAll('[data-pq-q0]').forEach(function (b) {
    b.addEventListener('click', function () { cueSound('A'); state.q0 = b.dataset.pqQ0; goTo('q1'); });
  });

  var PANEL_SLIDE_MS = 2400;
  var FINALISING_HOLD_MS = 1200;
  function advanceToCapture() {
    goTo('transition');
    setTimeout(function () { cueSound('B'); }, PANEL_SLIDE_MS);
    setTimeout(function () { showCapture(); goTo('final'); }, PANEL_SLIDE_MS + FINALISING_HOLD_MS);
  }

  root.querySelectorAll('[data-pq-q1]').forEach(function (b) {
    b.addEventListener('click', function () {
      cueSound('A');
      state.q1 = b.dataset.pqQ1;
      if (state.q1 === 'D') { state.isDexit = true; advanceToCapture(); return; }
      state.isDexit = false;
      goTo('q2');
    });
  });

  root.querySelectorAll('[data-pq-q2]').forEach(function (b) {
    b.addEventListener('click', function () { cueSound('A'); state.q2 = b.dataset.pqQ2; state.hairWord = b.dataset.pqQ2Word || ''; advanceToCapture(); });
  });

  // ── Capture, Klaviyo + localStorage handoff ─────────────────────────────────
  var formEl = root.querySelector('[data-pq-form]');
  var emailInput = formEl && formEl.querySelector('[name="email"]');
  var emailErrEl = formEl && formEl.querySelector('.pq-email-err');
  function validateEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim()); }
  if (emailInput && emailErrEl) {
    emailInput.addEventListener('blur', function () { emailErrEl.hidden = !(emailInput.value && !validateEmail(emailInput.value)); });
    emailInput.addEventListener('input', function () { if (!emailErrEl.hidden && validateEmail(emailInput.value)) emailErrEl.hidden = true; });
  }

  function currentHero() {
    if (state.isDexit) return null;
    var sm = FREQ[state.q1] && FREQ[state.q1].shavesMonth;
    var bl = HAIR[state.q2] && HAIR[state.q2].bladeLife;
    return candidates(state.q0 === 'yes', sm, bl)[0] || null;
  }

  // Recommended products for the current answers, hero first. Mirrors the result screen so
  // the email can show the recommendation. Persisted on the profile (see buildProfile) and
  // sent to Klaviyo as the recommended_products property; the email loops over it.
  function formatRecPrice(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(v);
    if (isNaN(n)) return String(v);
    return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function absUrl(u) {
    // Shopify image_url returns a protocol-relative URL (//cdn...); emails need an explicit scheme.
    if (!u) return null;
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }
  function recProduct(p, isHero) {
    return {
      title: p.title || '',
      description: p.description || null,
      image: absUrl(p.imageUrl),
      url: p.url || null,
      price: formatRecPrice(p.price),
      product_id: p.id,
      is_hero: !!isHero
    };
  }
  function recommendedProducts() {
    if (state.isDexit) {
      return POOL.filter(function (p) { return p.productType === 'SET' && p.available; })
        .sort(function (a, b) { return (parseFloat(a.price) || 0) - (parseFloat(b.price) || 0); })
        .map(function (p) { return recProduct(p, false); });
    }
    var sm = FREQ[state.q1] && FREQ[state.q1].shavesMonth;
    var bl = HAIR[state.q2] && HAIR[state.q2].bladeLife;
    var recs = candidates(state.q0 === 'yes', sm, bl);
    if (!recs || !recs.length) return [];
    var heroId = recs[0].product.id;  // candidates() ranks best-first, so the hero stays at index 0
    return recs.map(function (x) { return recProduct(x.product, x.product.id === heroId); });
  }

  function buildProfile() {
    var hero = currentHero();
    var key = hero ? tierKey(hero.product.title) : null;
    var sm = FREQ[state.q1] && FREQ[state.q1].shavesMonth;
    var bl = HAIR[state.q2] && HAIR[state.q2].bladeLife;
    return {
      tier: key ? MEMBER_NOUN[key] : null,             // member-noun: tiers section keys on this
      order_name: key ? ORDER_NAME[key] : null,        // Order adjective for landing-page copy
      cadence_months: hero ? hero.match.months : null,
      hair: state.hairWord || (HAIR[state.q2] && HAIR[state.q2].label) || '',  // display word
      frequency: (FREQ[state.q1] && FREQ[state.q1].label) || '',               // display label
      blades_year: (sm && bl) ? Math.round(custBladesYear(sm, bl)) : null,     // customer consumption
      q_freq: state.q1, q_hair: state.q2, owns_razor: state.q0 === 'yes',
      product_id: hero ? hero.product.id : null,
      recommended_products: recommendedProducts(),
      first_name: state.firstName,
      ts: Date.now()                                  // recency for the KG A/B state engine
    };
  }

  function writeProfile(profile) {
    try { localStorage.setItem('porticoProfile', JSON.stringify(profile)); } catch (e) { /* private mode: Klaviyo still has it */ }
  }

  // Capture goes through Klaviyo's client-side API, not onsite identify/track.
  // Onsite track only records "known" (cookied) browsers and silently drops anonymous
  // first-time quiz takers, so the Client Event endpoint is used instead: it creates the
  // profile, the "Took Portico Quiz" metric, and the properties server-side regardless of
  // cookie state. The onsite identify below is best-effort, only to tie the browser session
  // to the profile for Active-on-Site; capture does not depend on it.
  function sendToKlaviyo(email, profile) {
    var company = CONFIG.klaviyoPublicKey;
    var REV = '2025-07-15';

    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { email: email, first_name: profile.first_name }]);
    } catch (e) { /* onsite optional */ }

    if (!company) return;

    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: { recommended_portico_tier: profile.tier, recommended_portico_cadence_months: profile.cadence_months, quiz_owns_razor: profile.owns_razor },
            metric: { data: { type: 'metric', attributes: { name: 'Took Portico Quiz' } } },
            profile: { data: { type: 'profile', attributes: {
              email: email,
              first_name: profile.first_name,
              properties: {
                recommended_portico_tier: profile.tier,
                recommended_portico_cadence_months: profile.cadence_months,
                recommended_order_name: profile.order_name,
                quiz_shave_frequency: profile.frequency,
                quiz_hair_type: profile.hair,
                quiz_blades_year: profile.blades_year,
                quiz_owns_razor: profile.owns_razor,
                email_consent: state.emailConsent,
                recommended_products: profile.recommended_products
              }
            } } }
          }
        }
      })
    }).catch(function () { /* fire-and-forget; localStorage already has the profile */ });

    // Marketing consent: subscribe to the Newsletter list only when the box was ticked.
    if (state.emailConsent && CONFIG.newsletterListId) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REV },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: CONFIG.newsletterListId } } }
          }
        })
      }).catch(function () { /* consent best-effort; event still captured */ });
    }
  }

  if (formEl) formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    if (emailInput && !validateEmail(emailInput.value)) { if (emailErrEl) emailErrEl.hidden = false; if (emailInput) emailInput.focus(); return; }
    if (emailErrEl) emailErrEl.hidden = true;
    var fd = new FormData(formEl);
    state.firstName = (fd.get('firstName') || '').toString().trim();
    state.emailConsent = fd.get('marketingConsent') === 'yes';
    var profile = buildProfile();
    writeProfile(profile);
    sendToKlaviyo((emailInput.value || '').trim(), profile);
    cueSound('C');
    showResult(state.isDexit);
  });

  var skipEl = root.querySelector('[data-pq-skip]');
  if (skipEl) skipEl.addEventListener('click', function () {
    writeProfile(buildProfile()); // skip writes the profile locally, sends nothing to Klaviyo
    cueSound('C');
    showResult(state.isDexit);
  });

  // ── Checkout: card CTA → /cart/add.js + selling plan → /checkout ────────────
  function addToCheckout(variantId, sellingPlan, button, giftLines) {
    if (!variantId) return;
    if (button) button.disabled = true;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    // The gift rides in this same call; the auto-add runner debounces 150ms and
    // loses the race to window.location below. See assets/kg-portico-add.js.
    var items = window.kgPorticoBuildItems
      ? window.kgPorticoBuildItems(item, JSON.stringify(giftLines || []))
      : [item];
    fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart/add failed: ' + r.status); window.location = '/checkout'; })
      .catch(function (err) { if (button) button.disabled = false; console.error('[portico-quiz] checkout failed', err); });
  }

  // SET handle change → swap the card photo + Set Contents grid to the selected variant.
  function swapHandle(card, variantId) {
    var prod = findProd(card.getAttribute('data-pq-prod-id'));
    if (!prod) return;
    var view = setVariantView(prod, variantId);
    var photoWrap = card.querySelector('.pq-card-photo');
    if (photoWrap) photoWrap.innerHTML = view.image
      ? '<img src="' + esc(view.image) + '" alt="' + esc(prod.title) + '" loading="lazy">'
      : '<div class="pq-media-ph">Product image</div>';
    // Set Contents is what the set contains, paid. The gift has its own
    // dropdown and does not change with the handle, so it is not swapped here.
    var contentsEl = card.querySelector('[data-pq-contents]');
    if (contentsEl) contentsEl.innerHTML = card.getAttribute('data-pq-mode') === 'subscription'
      ? contentsGrid(view.hardware)
      : contentsGrid(view.allContents);
    requestAnimationFrame(equaliseCadenceRows);
  }

  var cardsHost = root.querySelector('[data-pq-cards]');
  if (cardsHost) {
    cardsHost.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-pq-handle-opt]');
      if (pill) {
        var pcard = pill.closest('.pq-card');
        if (!pcard) return;
        cueSound('A');
        pcard.querySelectorAll('.pq-pill').forEach(function (p) { p.classList.toggle('is-selected', p === pill); });
        var vid = pill.getAttribute('data-variant-id');
        var hidden = pcard.querySelector('[data-pq-handle]');
        if (hidden) hidden.value = vid;
        swapHandle(pcard, vid);
        return;
      }
      var btn = e.target.closest('[data-pq-join]');
      if (!btn) return;
      cueSound('A');
      var card = btn.closest('.pq-card');
      var variantId = btn.getAttribute('data-variant-id');
      var handle = card && card.querySelector('[data-pq-handle]'); // SET: chosen handle overrides variant
      if (handle && handle.value) variantId = handle.value;
      var prod = card && findProd(card.getAttribute('data-pq-prod-id'));
      addToCheckout(variantId, btn.getAttribute('data-selling-plan'), btn, prod && prod.giftLines);
    });
    // Sync dropdowns of the same kind across all cards: opening "Set Contents" on one opens it on all.
    cardsHost.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.matches || !d.matches('.pq-disclosure[data-pq-dd]')) return;
      var kind = d.getAttribute('data-pq-dd');
      var open = d.open;
      cardsHost.querySelectorAll('.pq-disclosure[data-pq-dd="' + kind + '"]').forEach(function (other) {
        if (other !== d && other.open !== open) other.open = open;
      });
      requestAnimationFrame(equaliseCadenceRows);
    }, true);
  }

  // ── Hero advance, controls, result footer ───────────────────────────────────
  var heroEl = panel('hero');
  var wheelLock = false;
  if (heroEl) {
    heroEl.addEventListener('wheel', function (e) {
      if (cur !== 'hero') return;
      if (e.deltaY > 0 && !wheelLock) { wheelLock = true; cueSound('B'); startAmbient(); goTo(firstAfterHero()); setTimeout(function () { wheelLock = false; }, 2450); }
    }, { passive: true });
    var ty = null;
    heroEl.addEventListener('touchstart', function (e) { ty = e.touches[0].clientY; }, { passive: true });
    heroEl.addEventListener('touchend', function (e) {
      if (ty != null && cur === 'hero' && (ty - e.changedTouches[0].clientY) > 30) { cueSound('B'); startAmbient(); goTo(firstAfterHero()); }
      ty = null;
    }, { passive: true });
  }
  // Q0 is skipped when the visitor is known to own a razor (URL param); jump straight to Q1.
  function firstAfterHero() { return q0Skipped ? 'q1' : 'q0'; }

  root.querySelectorAll('[data-pq-advance]').forEach(function (el) {
    el.addEventListener('click', function () { if (cur === 'hero') { cueSound('A'); cueSound('B'); startAmbient(); goTo(firstAfterHero()); } });
  });

  if (upBtn) upBtn.addEventListener('click', function () {
    cueSound('A');
    var i = PANEL_ORDER.indexOf(cur);
    var prev = PANEL_ORDER[Math.max(0, i - 1)];
    if (prev === 'transition') prev = PANEL_ORDER[Math.max(0, i - 2)];
    if (prev === 'q0' && q0Skipped) prev = 'hero';
    goTo(prev);
  });

  var porticoLink = root.querySelector('[data-pq-portico]');
  if (porticoLink && CONFIG.porticoUrl) porticoLink.setAttribute('href', CONFIG.porticoUrl);

  var restartEl = root.querySelector('[data-pq-restart]');
  if (restartEl) restartEl.addEventListener('click', function () { cueSound('A'); state.isDexit = false; if (controlsEl) controlsEl.style.display = ''; showCapture(); goTo('hero'); });

  var PQ_ICON_ON = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/>';
  var PQ_ICON_OFF = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M22 9l-6 6M16 9l6 6"/>';
  var soundSvg = soundBtn && soundBtn.querySelector('svg');
  if (soundBtn) soundBtn.addEventListener('click', function () {
    var on = soundBtn.getAttribute('aria-pressed') !== 'true';
    soundBtn.setAttribute('aria-pressed', on);
    soundBtn.title = on ? 'Sound on' : 'Sound off';
    if (soundSvg) soundSvg.innerHTML = on ? PQ_ICON_ON : PQ_ICON_OFF;
    if (on && ambientUnlocked) startAmbient(); else ambientEl.pause();
  });

  // ── Init ────────────────────────────────────────────────────────────────────
  var q0Skipped = false;
  (function applyOwnsParam() {
    var key = CONFIG.ownsParam || 'owns';
    var params = new URLSearchParams(window.location.search);
    if (!params.has(key)) return;
    var v = params.get(key);
    state.q0 = (v === '0' || v === 'no' || v === 'false') ? 'no' : 'yes';
    q0Skipped = true;
    var q0Panel = panel('q0');
    if (q0Panel) q0Panel.hidden = true;
    var idx = PANEL_ORDER.indexOf('q0');
    if (idx >= 0) PANEL_ORDER.splice(idx, 1); // drop q0 from the slider order
  })();

  window.addEventListener('resize', function () { setPanelHeights(); equaliseCadenceRows(); });

  try {
    POOL = parsePool(RAW_POOL);
    var ready = POOL.filter(function (p) { return p.ready; }).length;
    if (!POOL.length) throw new Error('empty pool: check the recommendable collection emit');
    console.info('[portico-quiz] pool ' + POOL.length + ' products, ' + ready + ' ready');
    setPanelHeights();
    goTo('hero', true);
    // Theme-editor only: skip the flow and show the chosen result so schema edits don't force a click-through.
    if (window.Shopify && Shopify.designMode && CONFIG.previewResult) {
      var preset = PREVIEW_PRESETS[CONFIG.previewVariant] || PREVIEW_PRESETS['membership-frequent'];
      Object.keys(preset).forEach(function (k) { state[k] = preset[k]; });
      goTo('final', true);
      showResult(state.isDexit);
    }
  } catch (err) {
    console.error('[portico-quiz] init failed', err);
  }
})();
